import { isWithinInterval } from "date-fns";
import { getChartName } from "../../helpers/UtilityHelper";
import DateIntervalStrategy from "../DateIntervalStrategy";

export class TATPerformance extends DateIntervalStrategy {

    dataList = [];

    constructor(queryParams, _api) {
        super(queryParams.groupOn, queryParams.fromDate, queryParams.toDate)
        this.groupOn = queryParams.groupOn || 'DOD';
        const keyLists = Object.keys(_api.getState().courierPerformanceApi.queries).filter(key => key.includes('getTATMetrics'))
        for (const key of keyLists) {
            const originalData = _api.getState().courierPerformanceApi.queries[key]?.originalArgs
            const isFulfilled = _api.getState().courierPerformanceApi.queries[key]?.status === 'fulfilled'

            const isSameFromDate = originalData.fromDate === queryParams.fromDate
            const isSameToDate = originalData.toDate === queryParams.toDate

            if (isFulfilled && isSameFromDate && isSameToDate) {
                this.dataList = _api.getState().courierPerformanceApi.queries[key]?.data || []
            }
        }
    }

    dataGroupByDate() {
        return this.dataList.reduce((acc, item) => {
            const date = item.awbRegisteredDay;
            if (!acc.has(date)) {
                acc.set(date, []);
            }
            acc.get(date)?.push(item);
            return acc;
        }, new Map())
    }

    getPerformaceTrend() {
        const dataGroupByDate = this.dataGroupByDate();
        const dataMaPKeys = Array.from(dataGroupByDate.keys());

        const tatPerformanceTrend = []

        for (const index in this.interval.slice(0, -1)) {
            const start = this.interval[index]
            const end = this.interval[+index + 1] || start

            const dataWithInInterval = dataMaPKeys
                .filter((date) => isWithinInterval(new Date(date), { start, end }))
                .map((date) => dataGroupByDate.get(date) || [])
                .flat();

            tatPerformanceTrend.push({
                name: getChartName({ groupOn: this.groupOn, start, end }),
                data: this.getPerformace(dataWithInInterval),
            })
        }

        return tatPerformanceTrend;
    }

    groupByCourierId(dataList) {
        return dataList.reduce((acc, item) => {
            const courierId = item.courierId;
            if (!acc.has(courierId)) {
                acc.set(courierId, []);
            }
            acc.get(courierId)?.push(item);
            return acc;
        }, new Map())
    }

    getSumByProperty(property, dataList) {
        return dataList.reduce((acc, item) => {
            return acc + ((item[property] || 0))
        }, 0);
    }

    calculatePercentage(numerator, denominator) {
        return numerator / denominator * 100 || 0;
    }

    getPerformaceSplit(dataList) {
        const totalDeliveredShipmentCount = this.getSumByProperty('totalDeliveredShipmentCount', dataList)
        const firstDeliveryAttemptInTATCount = this.getSumByProperty('firstDeliveryAttemptInTATCount', dataList)
        const deliveredInTATCount = this.getSumByProperty('deliveredInTATCount', dataList)
        const deliveredInTATPlusOneCount = this.getSumByProperty('deliveredInTATPlusOneCount', dataList)
        const deliveredInTATPlusTwoCount = this.getSumByProperty('deliveredInTATPlusTwoCount', dataList)
        const deliveredInTATPlusThreeCount = this.getSumByProperty('deliveredInTATPlusThreeCount', dataList)
        return {
            totalDeliveredShipmentCount,
            firstDeliveryAttemptInTATCount,
            deliveredInTATCount,
            deliveredInTATPlusOneCount,
            deliveredInTATPlusTwoCount,
            deliveredInTATPlusThreeCount,
            firstDeliveryAttemptInTATPercentage: this.calculatePercentage(firstDeliveryAttemptInTATCount, totalDeliveredShipmentCount),
            tatAdherence: this.calculatePercentage(deliveredInTATCount, totalDeliveredShipmentCount),
            tatPlusOneAdherence: this.calculatePercentage(deliveredInTATPlusOneCount + deliveredInTATCount, totalDeliveredShipmentCount),
            tatPlusTwoAdherence: this.calculatePercentage(deliveredInTATPlusTwoCount + deliveredInTATPlusOneCount + deliveredInTATCount, totalDeliveredShipmentCount),
            tatPlusThreeAdherence: this.calculatePercentage(deliveredInTATPlusThreeCount + deliveredInTATPlusTwoCount + deliveredInTATPlusOneCount + deliveredInTATCount, totalDeliveredShipmentCount)
        }

    }

    getPerformace(dataList) {
        const courierWiseData = this.groupByCourierId(dataList || this.dataList);
        return Array.from(courierWiseData.entries()).reduce((acc, [courierId, dataList]) => {
            acc.set(courierId, {
                courierId,
                ...this.getPerformaceSplit(dataList)
            })
            return acc;
        }, new Map())
    }
}
